"use client";

import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const EditModeContext = createContext();

export const useEditMode = () => useContext(EditModeContext);

export const EditModeProvider = ({ children, initialData }) => {
  const [contents, setContents] = useState(initialData || {});

  useEffect(() => {
    if (initialData) {
        setContents(prev => {
            if (JSON.stringify(prev) !== JSON.stringify(initialData)) {
                return initialData;
            }
            return prev;
        });
    }
    fetchContents();
  }, [initialData]);

  const fetchContents = async () => {
    try {
      const apiUrl = process.env.NEXT_PUBLIC_API_URL || 'https://controller.gefestai.com/api';
      const response = await axios.get(`${apiUrl}/site-contents`);
      
      setContents(prevContents => {
        if (JSON.stringify(prevContents) !== JSON.stringify(response.data)) {
            return response.data;
        }
        return prevContents;
      });
    } catch (error) {
      console.error('Failed to fetch site contents client-side', error);
    }
  };

  const getContent = (key, defaultValue) => {
    return contents[key] !== undefined ? contents[key] : defaultValue;
  };

  return (
    <EditModeContext.Provider value={{ getContent }}>
      {children}
    </EditModeContext.Provider>
  );
};